var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.videoId)?_c('div',{staticClass:"brightcove-main mx-auto"},[_c('iframe',{staticClass:"brightcove-iframe",attrs:{"src":`https://players.brightcove.net/6110393209001/default_default/index.html?videoId=${_vm.videoId}`,"allow":"encrypted-media","allowfullscreen":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }